// extracted by mini-css-extract-plugin
export default {"banner":"SuspensionBanner_banner__9f1S5","text":"SuspensionBanner_text__idfNC","label":"SuspensionBanner_label__-0XlP","message":"SuspensionBanner_message__NWiQL"};